export const OPEN_RIBBON_DROPDOWN_MENU = 'OPEN_RIBBON_DROPDOWN_MENU'
export const CLOSE_RIBBON_DROPDOWN_MENU = 'CLOSE_RIBBON_DROPDOWN_MENU'
export const TOGGLE_RIBBON_DROPDOWN_MENU = 'TOGGLE_RIBBON_DROPDOWN_MENU'
export const ACTIVE_RIBBON_DROPDOWN_ITEM = 'ACTIVE_RIBBON_DROPDOWN_ITEM'
